module.exports = __webpack_public_path__ + "img/architectureImg5.6dafeb5a.jpeg";